import { useLiveQuery } from 'dexie-react-hooks';
import { db, type Ring } from 'technical/db';

export const useNbSegmentsByRing = (ring?: Ring | undefined | null) => {
  const maxSegmentsByRing = useLiveQuery(
    () => db.segmentDrawConfigs.count(),
    [],
  );

  const currentRingInstalledSegments = useLiveQuery(() => {
    if (!ring) {
      return 0;
    }
    return db.segments.where('ringId').equals(ring.id).count();
  }, [ring?.id]);

  return { maxSegmentsByRing, currentRingInstalledSegments };
};
